/// <reference types="./leaflet.vectorgrid" />

import { Component, OnInit, Input, OnChanges, SimpleChanges, Output, EventEmitter, OnDestroy } from '@angular/core';
import * as leaflet from 'leaflet';
// import 'leaflet.vectorgrid';
import { ensurePane } from './leaflet.service';
import { TiledSublayerDescriptor } from './data';
import { tooltipForFeature } from './geojson-layer.component';
import { LeafletMapComponent } from './leaflet-map.component';

@Component({
  selector: 'vector-tile-layer',
  template: '',
  styles: []
})
export class VectorTileLayerComponent implements OnInit, OnChanges, OnDestroy {
  @Input() url: string;
  @Input() styles: any;
  @Input() highlightedFeatureStyles: any = {
    weight: 5
  };
  @Input() sublayers: TiledSublayerDescriptor[] = [];
  @Output() featureSelected = new EventEmitter<any>();
  @Input() minZoom = 0;
  @Input() maxZoom = 30;
  @Input() minNativeZoom = 11;
  @Input() maxNativeZoom = 13;
  @Input() zIndex = 100;
  @Input() tooltipFormat: ((f:any)=>string) | string;
  @Output() loading = new EventEmitter<boolean>();
  private destroyed = false;
  private selectedFeature: any;
  private mainVectorLayer: L.VectorGridLayer;
  private highlightVectorLayer: L.VectorGridLayer;
  private handlingClick =false;

  constructor(private map: LeafletMapComponent) { }

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
    this.destroyed = true;
    if(this.map.map){
      this.remove(this.map.map);
    }
  }

  private getFeatureId(f:any): string {
    const match = this.sublayers.find(lyr=>{
      const lookupVal = f.properties[lyr.keyField]
      return !((lookupVal===null)||(lookupVal===undefined));
    });
    return f.properties[match.keyField];
  }

  private remove(m: L.Map): void {
    this.mainVectorLayer = this.removeLayer(m,this.mainVectorLayer);
    this.highlightVectorLayer = this.removeLayer(m,this.highlightVectorLayer);
  }

  private removeLayer(m: leaflet.Map, l: leaflet.VectorGridLayer):any {
    if(l){
      l.removeFrom(m);
      l.off();
    }
    return null;
  }

  ngOnChanges(changes: SimpleChanges): void {

    this.map.withMap((m: L.Map) => {
      this.updateLayer();
    });
  }

  updateLayer(){
    const m = this.map.map;
    this.remove(m);
    if(this.destroyed){
      return;
    }

    if(!this.url){
      console.error('VectorTileLayerComponent: url is required');
      return;
    }

    this.mainVectorLayer = this.makeLayer(m,this.zIndex);
    this.highlightVectorLayer = this.makeLayer(m,this.zIndex+1,false);
    // this.highlightVectorLayer.bindTooltip((layer:any)=>{
    //   return tooltipForFeature(this.tooltipFormat||'tooltip:{{GID_0}}',layer.feature);
    // },{
    // 	sticky: true,
    // 	direction: 'auto',
    // 	className: ''
    // });

    if(this.featureSelected.observers.length){
      this.highlightVectorLayer.on('click' as any,(event:leaflet.LeafletMouseEvent)=>{
        this.handlingClick = true;
        setTimeout(()=>{
          if(!this.handlingClick){
            return;
          }
          this.handlingClick = false;
          if(!this.featureSelected.observers.length){
            return;
          }

          if(this.selectedFeature){
            this.highlightVectorLayer.resetFeatureStyle(this.selectedFeature);
          }
          this.selectedFeature = this.getFeatureId(event.layer);
          this.highlightVectorLayer.setFeatureStyle(this.selectedFeature,this.highlightStyles());
          this.highlightVectorLayer.redraw();

          const geoJSON = this.vectorGridFeatureToGeoJSON(event.layer);
          this.featureSelected.emit(geoJSON);
          event.originalEvent.stopPropagation();
          event.originalEvent.preventDefault();
        });

      });

      this.highlightVectorLayer.on('dblclick' as any,(event)=>{
        this.handlingClick = false;
      });

      // this.highlightVectorLayer.on('mouseover', (event: L.LeafletMouseEvent) => {
      //   console.log('mouseover',event.layer?.properties?.NAME_0);
      // });

      // this.highlightVectorLayer.on('mouseout' as any, (event: L.LeafletMouseEvent) => {
      //   console.log('mouseout',event);
      // });
    }
  }

  private makeLayer(map:leaflet.Map,zIndex:number,tooltips=false): leaflet.VectorGridLayer {
    const pane = `vector-pane-${zIndex}`;
    ensurePane(map,pane,zIndex)

    let result = L.vectorGrid.protobuf(this.url,{
      pane,
      minZoom:this.minZoom,
      maxZoom:this.maxZoom,
      minNativeZoom:this.minNativeZoom,
      maxNativeZoom:this.maxNativeZoom,
      interactive: true,//!!this.featureSelected.observers.length,
      vectorTileLayerStyles: this.styles,
      getFeatureId: (f:any) => this.getFeatureId(f)
    });

    if(tooltips){
      result = result.bindTooltip((layer:any)=>{
        return tooltipForFeature(this.tooltipFormat||'tooltip:{{GID_0}}',layer.feature);
      });
    }

    result.addTo(map);
    result.on('loading',(event)=>{
      this.loading.emit(true);
    });
    result.on('load',(event)=>{
      this.loading.emit(false);
    });
    return result;
  }

  highlightStyles():any {
    let modStyle:any = {...this.highlightedFeatureStyles,zIndex:this.zIndex+1};

    if(Object.keys(this.styles).length===1){
      let existingStyle = this.styles[Object.keys(this.styles)[0]];
      if(typeof(existingStyle)==='function'){
        return (f:any)=>{
          return {...existingStyle(f),...modStyle};
        }
      }
      return {...existingStyle,...modStyle};
    }
    return modStyle;
  }

  vectorGridFeatureToGeoJSON(lyr:any):any{
    const parts:any[][] = (lyr._parts[0]&&lyr._parts[0][0])?lyr._parts:[lyr._parts];
    const points = (parts as any[]).map((part:any[])=>{
      return part.map(pt=>([pt.x,pt.y] as number[]));
    });
    const originalXs = ([] as number[]).concat(...points.map(part=>part.map(pt=>pt[0])));
    const minx = Math.min(...originalXs);//points[0].map(pt=>pt[0]));
    const maxx = Math.max(...originalXs);//points[0].map(pt=>pt[0]));

    const originalYs = ([] as number[]).concat(...points.map(part=>part.map(pt=>pt[1])));
    const miny = Math.min(...originalYs);//points[0].map(pt=>pt[1]));
    const maxy = Math.max(...originalYs);//points[0].map(pt=>pt[1]));

    function converter(from:number[],to:number[]): ((c:number)=>number) {
      const fromDelta = from[1]-from[0];
      const toDelta = to[1] - to[0];
      return (c)=>to[0] + ((c-from[0])/fromDelta) * toDelta;
    }

    const xConverter = converter([minx,maxx],[lyr.properties.minx,lyr.properties.maxx]);
    const yConverter = converter([miny,maxy],[lyr.properties.maxy,lyr.properties.miny]);

    return {
      type:'Feature',
      geometry:{
        type:'Polygon',
        coordinates:points.map(part=>part.map(pt=>[xConverter(pt[0]),yConverter(pt[1])]))
      },
      properties:lyr.properties
    };
  }

}

/*
      // m.off('zoom viewreset',(l as any)._resetView,l);
      // m.off('moveend',(l as any)._onMoveEnd,l);
      // m.off('zoomanim',(l as any)._animateZoom,l);
      // m.off('viewprereset',(l as any)._invalidateAll,l);
      // m.off('move',(l as any).wrapperFn,l);

Object.keys(m._events).forEach(k=>{
    m._events[k].forEach(lyr=>{
        if(lyr.ctx===l){
            console.log(k,lyr.fn.name);
        }
    });
});
*/